import { hasActiveObservations as t } from "./ghl-ui.es1721.js";
import { hasSkippedObservations as e } from "./ghl-ui.es1722.js";
import { deliverResizeLoopError as i } from "./ghl-ui.es1723.js";
import { broadcastActiveObservations as s } from "./ghl-ui.es1724.js";
import { gatherActiveObservationsAtDepth as o } from "./ghl-ui.es1725.js";
var n = function() {
  var r = 0;
  for (o(r); t(); )
    r = s(), o(r);
  return e() && i(), r > 0;
};
export {
  n as process
};
